
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/widerrufsrecht",
      function () {
        return require("private-next-pages/widerrufsrecht/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/widerrufsrecht"])
      });
    }
  